import { Injectable } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { TokenService } from './token.service';

export const AuthGuard: CanActivateFn = (route, state) => {
  const token = inject(TokenService);
  const router = inject(Router);
  if (token.getToken()) return true;
  router.navigate(['/login']);
  return false;
};
